var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 2H7.00098C4.23955 2 2.00098 4.23858 2.00098 7V17C2.00098 19.7614 4.23955 22 7.00098 22H17.001C19.7624 22 22.001 19.7614 22.001 17V7C22.001 4.23858 19.7624 2 17.001 2Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 11.3699C16.1236 12.2022 15.9815 13.0522 15.594 13.799C15.2065 14.5457 14.5933 15.1513 13.8418 15.5296C13.0903 15.9079 12.2386 16.0395 11.408 15.9059C10.5773 15.7722 9.80996 15.38 9.21503 14.7851C8.62011 14.1902 8.22793 13.4228 8.09426 12.5921C7.9606 11.7615 8.09226 10.9098 8.47052 10.1583C8.84878 9.40679 9.45438 8.79368 10.2012 8.40618C10.948 8.01868 11.7979 7.87652 12.6302 7.99994C13.4791 8.12582 14.265 8.5214 14.8719 9.12824C15.4787 9.73508 15.8743 10.521 16.0002 11.3699Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.499 6.5H17.509",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgInstagram;